import Card from "./Card";
import { CardListProps } from "../../../interfaces";

const CardList = ({ data = [], searchResult }: CardListProps) => {
  return (
    <>
      {data
        .filter(({ state, name, enabled, _id }) =>
          name?.toLowerCase().includes(searchResult?.toLowerCase())
        )
        .map(({ state, code, _id, enabled, name }: any) => (
          <Card
            key={_id}
            id={_id}
            name={name}
            code={code}
            isSelected={enabled ? true : false}
          />
        ))}
    </>
  );
};

export default CardList;
